import React, { useCallback } from 'react';

import providerType from './providerType';
import settings from './settings';

const Provider = ({
  ID: id,
  displayName,
  logoURL,
  setLocalSelectedProvider,
  disableAdobeCallback,
}) => {
  /**
   * URL of the service that is hosting the logo for
   * the providers that do not include it.
   *
   * @type {string}
   */
  const URL = 'https://media.psg.nexstardigital.net/tve-providers';

  const setProvider = useCallback(() => {
    setLocalSelectedProvider(id);
    if (! disableAdobeCallback) {
      window.AE.setSelectedProvider(id);
    }
  },
  [id]);

  /**
   * List of providers (ID) that do not have a logo.
   *
   * @type {Array}
   */
  // eslint-disable-next-line max-len
  const providersWithoutLogo = settings('providers_without_logo') || [];

  /**
   * Get the provider logo URL.
   *
   * As Adobe does not offer the logo for some providers, those
   * ones that are missing are hosted in an external service,
   * where they are retrived from.
   *
   * @return {string} Provider logo URL.
   */
  const getLogoURL = () => {
    /*
      The URL is still included in logoURL, but it is not usable.
      So checking if logoURL is undefined or null is not enough in
      this case.
    */
    const pid = id.toLowerCase();
    // eslint-disable-next-line max-len
    if (Array.isArray(providersWithoutLogo) && providersWithoutLogo.includes(pid)) {
      return `${URL}/${pid}.png`;
    }
    return logoURL;
  };

  return (
    <button
      type="button"
      onClick={setProvider}
    >
      {logoURL ? (
        <img alt={displayName} src={getLogoURL()} />
      ) : (
        displayName
      )}
    </button>
  );
};

Provider.defaultProps = {
  logoURL: '',
  setLocalSelectedProvider: () => {},
  disableAdobeCallback: false,
};

Provider.propTypes = providerType;

export default Provider;
